import { selectUserContext } from 'core/userContext';
import I18nSelector from 'modules/i18nSelector';
import { NAVBAR_PROJECT_SETTINGS } from 'modules/nav/types';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Body2, colors, H4, spacing } from 'ui/theme';
import { closeNav } from '../../ducks/actions';
import { ORGANIZATION_LINKS } from '../../constants/settingsMenu';
import { createCurrentProjectLinks, filterLinksByAccessible } from '../../utils/navlinks';
import { NavSlider } from '../NavSlider';
import { MenuOption } from './MenuOption';
import {
  FooterWrapper,
  Heading,
  OptionsContainer,
  SectionContainer,
  SectionHeader,
} from './styles';

export const TEXT = {
  HEADER: 'Settings',
  ORGANIZATION: 'Organization',
  CURRENT_PROJECT: 'Current project',
};

const Subheading = styled(Body2)`
  color: ${colors.textSecondary};
  max-width: ${spacing.x12};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SettingsMenu = () => {
  const { accountType, companyName, featureFlags, orgAdmin, project, rbacPermissions } =
    useSelector(selectUserContext);
  const { UserLocalizationSelection } = featureFlags;
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(closeNav());
  };

  const organizationLinks = filterLinksByAccessible({
    accountType,
    featureFlags,
    rbacPermissions,
    links: ORGANIZATION_LINKS,
    settings: {
      [NAVBAR_PROJECT_SETTINGS.orgAdmin]: !!orgAdmin,
    },
  });
  const projectLinks = createCurrentProjectLinks({
    accountType,
    featureFlags,
    projectId: project?.id,
    rbacPermissions,
  });

  return (
    <NavSlider onClose={onClose} headerContent={<H4>{TEXT.HEADER}</H4>}>
      <OptionsContainer data-test="mediumSettingsSliderMenu">
        <SectionContainer>
          <SectionHeader>
            <Heading>{TEXT.ORGANIZATION}</Heading>
            {companyName && <Subheading>{companyName}</Subheading>}
          </SectionHeader>
          {organizationLinks.map((link) => (
            <MenuOption key={link.title} {...link} />
          ))}
        </SectionContainer>

        <SectionContainer>
          <SectionHeader>
            <Heading>{TEXT.CURRENT_PROJECT}</Heading>
            {project?.name && <Subheading>{project.name}</Subheading>}
          </SectionHeader>
          {projectLinks.map((link) => (
            <MenuOption key={link.title} {...link} />
          ))}
        </SectionContainer>
      </OptionsContainer>
      {UserLocalizationSelection && (
        <FooterWrapper data-test="settings-footer">
          <I18nSelector />
        </FooterWrapper>
      )}
    </NavSlider>
  );
};
